// extracted by mini-css-extract-plugin
export default {"crossProductNote":"VerifiedEmail_crossProductNote__1wvRj","noWrap":"VerifiedEmail_noWrap__Kwui7"};